<template>
    <v-app>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container class="pt-10">
                    <a class="py-4" href="/dashboard">Личный кабинет</a>
                    /
                    <a class="py-4" href="/commissions">Вознаграждение</a>
                    <h1 v-if="id === -1" class="py-4">Новый шаблон вознаграждения</h1>
                    <h1 v-else class="py-4">Шаблон вознаграждения</h1>
                </v-container>

                <v-container>
                    <v-layout row>
                        <v-flex xs12 sm6 md3 v-if="type !== 'transit'">
                            <v-text-field
                                v-model.lazy="regionSearch"
                                label="Регион"
                                placeholder="Начните вводить регион"
                                clearable
                            />
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                            <v-text-field
                                label="Название шаблона"
                                :rules="[rules.notNullOrEmpty, rules.maxLength, rules.forbiddenCharsRule]"
                                counter="40"
                                v-model="templateName"
                                @keyup.native="templateName = removeSymbols(templateName)"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>

                <v-container>
                    <v-layout row align-center class="mb-4">
                        <div class="region-field">
                            <span class="text-h6 font-weight-bold">{{ typeName }}</span>
                            <br>
                            <v-btn @click="validateAndSave"
                                   color="primary"
                                   class="submit-button">Сохранить</v-btn>
                        </div>
                    </v-layout>


                <b2b-commissions-table
                    v-if="type !== 'transit'"
                    :canEdit="true"
                    :regions="regions"
                    :companies="companies"
                    :commissions="commissions"
                    :commissionRules="commissionRules"
                    :regionSearch="regionSearch"
                />

                <b2b-commissions-transit
                    v-if="type === 'transit'"
                    :canEdit="true"
                    :regions="regions"
                    :companies="companies"
                    :commissions="commissions"
                    @update:commissions="commissions = $event"
                    :commissionRules="commissionRules"
                />
            </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    props: ['type', 'templateid', 'comps', 'regs', 'comms', 'admin', 'role', 'commrules', 'name'],

    data: () => ({
        valid: true,
        companies: [],
        regions: [],
        commissions: {},
        commissionRules: {},
        templateName: '',
        userRole: '',
        id: -1,
        typeName: 'ОСАГО',
        regionSearch: '',

        rules: {
            commission: v => ((/^[0-9]+/.test(v) && v <= 100) || v === '') || 'Ошибка',
            notNullOrEmpty: v => (v !== null && v !== undefined && v.trim() !== '') || 'Обязательное поле',
            maxLength: v => v.length <= 40 || 'Название шаблона не должно превышать 40 символов',
            forbiddenCharsRule: v => !/[{}!$@]/.test(v) || 'Запрещённые символы: { } ! $ @',
        },
    }),

    created() {
        this.id = this.templateid;
        // Для transit регионы приходят как JSON строка с массивом стран
        if (this.type === 'transit') {
            let regionsData;
            try {
                regionsData = typeof this.regs === 'string' ? JSON.parse(this.regs) : (this.regs || []);
            } catch (e) {
                regionsData = [];
            }
            // Преобразуем массив стран в объекты с id и val
            this.regions = Array.isArray(regionsData)
                ? regionsData.map((name, index) => ({
                    id: index.toString(),
                    val: name
                }))
                : (regionsData && typeof regionsData === 'object' ? Object.entries(regionsData).map(([id, name]) => ({
                    id: id.toString(),
                    val: name
                })) : []);
        } else {
            try {
                this.regions = (typeof this.regs === 'string' ? JSON.parse(this.regs) : this.regs) || [];
            } catch (e) {
                this.regions = [];
            }
        }
        if (!Array.isArray(this.regions)) {
            this.regions = [];
        }

        try {
            this.companies = (typeof this.comps === 'string' ? JSON.parse(this.comps) : this.comps) || [];
        } catch (e) {
            this.companies = [];
        }
        if (!Array.isArray(this.companies)) {
            this.companies = [];
        }
        // Теперь commissions передаются через @json(), поэтому они уже объект
        try {
            this.commissions = typeof this.comms === 'string' ? JSON.parse(this.comms) : (this.comms || {});
        } catch (e) {
            this.commissions = {};
        }
        if (typeof this.commissions !== 'object' || this.commissions === null) {
            this.commissions = {};
        }

        this.commissionRules = (this.commrules && typeof this.commrules === 'object') ? this.commrules : {};
        this.templateName = this.name;
        this.userRole = this.role;

        // Для transit преобразуем данные в формат company -> { countryId: value }
        if (this.type === 'transit') {
            const convertedCommissions = {};
            
            // Убеждаемся, что regions загружены, если нет - инициализируем пустыми значениями
            if (this.regions && this.regions.length) {
                this.companies.forEach(company => {
                    convertedCommissions[company.alias] = {};
                    const companyData = this.commissions && this.commissions[company.alias];
                    
                    if (companyData) {
                        if (Array.isArray(companyData)) {
                            // Массив преобразуем в объект с индексами как ID
                            companyData.forEach((value, index) => {
                                convertedCommissions[company.alias][index.toString()] = value || '';
                            });
                        } else if (typeof companyData === 'object' && companyData !== null) {
                            // Если объект уже с числовыми ключами (индексами), используем как есть
                            const firstKey = Object.keys(companyData)[0];
                            if (firstKey && !isNaN(parseInt(firstKey))) {
                                Object.keys(companyData).forEach(regionId => {
                                    convertedCommissions[company.alias][regionId] = companyData[regionId] || '';
                                });
                            } else {
                                // Объект с названиями стран преобразуем в ID
                                this.regions.forEach((region, index) => {
                                    const regionId = (typeof region === 'object' && region.id !== undefined) ? region.id.toString() : index.toString();
                                    const regionVal = (typeof region === 'object' && region.val) ? region.val : region;
                                    
                                    // Проверяем, есть ли значение для этой страны
                                    if (companyData.hasOwnProperty(regionVal)) {
                                        convertedCommissions[company.alias][regionId] = companyData[regionVal] || '';
                                    } else {
                                        convertedCommissions[company.alias][regionId] = '';
                                    }
                                });
                            }
                        }
                    } else {
                        // Инициализируем пустыми значениями
                        this.regions.forEach((region, index) => {
                            const regionId = (typeof region === 'object' && region.id !== undefined) ? region.id.toString() : index.toString();
                            convertedCommissions[company.alias][regionId] = '';
                        });
                    }
                });
            } else {
                // Если regions еще не загружены, инициализируем пустыми значениями
                this.companies.forEach(company => {
                    convertedCommissions[company.alias] = {};
                });
            }
            
            this.$set(this, 'commissions', convertedCommissions);
        } else {
            for (let cmp in this.companies) {
                if (!this.companies.hasOwnProperty(cmp)) continue;
                let company = this.companies[cmp];
                if (this.commissions[company.alias] === undefined) {
                    this.commissions[company.alias] = {}
                }
                if (this.commissionRules[company.alias] === undefined) {
                    this.commissionRules[company.alias] = {}
                }
                for (let rgn in this.regions) {
                    if (!this.regions.hasOwnProperty(rgn)) continue;
                    let region = this.regions[rgn];
                    if (this.commissions[company.alias][region.id] === undefined) {
                        this.commissions[company.alias][region.id] = 0;
                    }
                    if (this.commissionRules[company.alias][region.id] === undefined) {
                        this.commissionRules[company.alias][region.id] = 0;
                    }
                }
            }
        }

        this.typeName = (this.type === 'mortgage') ? 'Страхование ипотеки' :
            (this.type === 'osago') ? 'ОСАГО' :
            (this.type === 'crosses') ? 'Кросс-продукты' :
            (this.type === 'antimite') ? 'Антиклещ' :
            (this.type === 'transit') ? 'ОСАГО не РФ' : '';
    },

    mounted() {
        // Для transit пересчитываем commissions после монтирования, если данные есть
        if (this.type === 'transit') {
            if (this.regions && this.regions.length && this.commissions) {
                const convertedCommissions = {};
                this.companies.forEach(company => {
                    convertedCommissions[company.alias] = {};
                    const companyData = this.commissions && this.commissions[company.alias];
                    
                    if (companyData) {
                        if (Array.isArray(companyData)) {
                            // Массив преобразуем в объект с индексами как ID
                            companyData.forEach((value, index) => {
                                convertedCommissions[company.alias][index.toString()] = value || '';
                            });
                        } else if (typeof companyData === 'object' && companyData !== null) {
                            // Если объект уже с числовыми ключами (индексами), используем как есть
                            const firstKey = Object.keys(companyData)[0];
                            if (firstKey && !isNaN(parseInt(firstKey))) {
                                Object.keys(companyData).forEach(regionId => {
                                    convertedCommissions[company.alias][regionId] = companyData[regionId] || '';
                                });
                            } else {
                                // Объект с названиями стран преобразуем в ID
                                this.regions.forEach((region, index) => {
                                    const regionId = (typeof region === 'object' && region.id !== undefined) ? region.id.toString() : index.toString();
                                    const regionVal = (typeof region === 'object' && region.val) ? region.val : region;
                                    
                                    if (companyData.hasOwnProperty(regionVal)) {
                                        convertedCommissions[company.alias][regionId] = companyData[regionVal] || '';
                                    } else {
                                        convertedCommissions[company.alias][regionId] = '';
                                    }
                                });
                            }
                        }
                    } else {
                        // Инициализируем пустыми значениями
                        this.regions.forEach((region, index) => {
                            const regionId = (typeof region === 'object' && region.id !== undefined) ? region.id.toString() : index.toString();
                            convertedCommissions[company.alias][regionId] = '';
                        });
                    }
                });
                this.$set(this, 'commissions', convertedCommissions);
            }
        }
    },

    methods: {
        validateAndSave() {
            if (this.$refs.form.validate()) {
                this.save();
            } else {
                this.$nextTick(function() {
                    if (typeof PNotify !== 'undefined') {
                        PNotify.error('Проверьте правильность выделенных полей.');
                    }
                    this.goToFirstError();
                });
            }
        },

        goToFirstError() {
            if (this.$vuetify && this.$vuetify.goTo) {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            }
        },

        save() {
            let postData;
            
            if (this.type === 'transit') {
                // Сохраняем данные по индексам (без русских названий стран)
                const converted = {};
                Object.keys(this.commissions).forEach(alias => {
                    converted[alias] = [];
                    const companyComm = this.commissions[alias] || {};
                    
                    // Сортируем ключи по числовому значению и создаем массив
                    const sortedKeys = Object.keys(companyComm).sort((a, b) => {
                        const aNum = parseInt(a);
                        const bNum = parseInt(b);
                        return isNaN(aNum) || isNaN(bNum) ? 0 : aNum - bNum;
                    });
                    
                    // Заполняем массив значениями по индексам
                    sortedKeys.forEach(regionId => {
                        const index = parseInt(regionId);
                        if (!isNaN(index)) {
                            // Увеличиваем массив до нужного размера, если нужно
                            while (converted[alias].length <= index) {
                                converted[alias].push('');
                            }
                            converted[alias][index] = companyComm[regionId] || '';
                        }
                    });
                });
                
                postData = {
                    data: converted,
                    name_template: this.templateName.trim()
                };
                
                if (this.id !== -1) {
                    postData.id = this.id;
                }
            } else {
                postData = {
                    commissions: JSON.stringify(this.commissions),
                    name: this.templateName.trim()
                };
            }
            
            if (this.id !== -1) {
                axios.patch(
                    '/commission-template/' + this.id + '/update?type=' + this.type,
                    JSON.stringify(postData)
                ).then(response => {
                    if (response.data) {
                        this.id = response.data.id;
                        window.history.pushState(null, null, '/commission-template/' + this.id + '?type=' + this.type);
                    }
                    if (typeof PNotify !== 'undefined') {
                        PNotify.success('Изменения успешно сохранены.');
                    }
                }).catch(error => {
                    if (error.response && error.response.data && error.response.data.message) {
                        if (typeof PNotify !== 'undefined') {
                            PNotify.alert(error.response.data.message);
                        }
                    }
                });
            } else {
                axios.post(
                    window.location,
                    JSON.stringify(postData)
                ).then(response => {
                    if (response.data) {
                        this.id = response.data.id;
                        window.history.pushState(null, null, '/commission-template/' + this.id + '?type=' + this.type);
                    }
                    if (typeof PNotify !== 'undefined') {
                        PNotify.success('Изменения успешно сохранены.');
                    }
                }).catch(error => {
                    if (error.response && error.response.data && error.response.data.message) {
                        if (typeof PNotify !== 'undefined') {
                            PNotify.alert(error.response.data.message);
                        }
                    }
                });
            }
        },
        getUrl(path) {
            return window.location.origin + '/' + path
        },
        removeSymbols(text) {
            if (!text) return '';
            // Удаляем только запрещённые символы: { } ! $ @
            return text.replace(/[{}!$@]/g, '');
        },
    }
}
</script>

<style scoped>
.submit-button {
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
    text-transform: none;
    box-shadow: none;
    background-color: #00ba57;
    border-radius: 100px;
    height: 40px;
    margin-top: 10px;
}

.region-field {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left: 0;
}

/* Адаптивные стили */
@media (max-width: 960px) {
    .v-flex {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }

    .v-layout.row {
        flex-direction: column;
    }

    .v-flex.xs12 {
        width: 100%;
        max-width: 100%;
    }
}

/* Базовые стили для заголовков */
h1 {
    font-size: 2rem;
    font-weight: 700;
    color: #000000;
}

/* Стили для текстовых полей */
.v-text-field {
    margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/CommissionTemplate.vue